import BenefitsCard from './BenefitsCard'

export default BenefitsCard
